import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.fields = this.el.querySelectorAll('input,textarea,select');
        this.$submit = this.$('submit')[0]

        this.onFieldChange = (e) => {
            // console.log('change', e);
            this.$submit.disabled = !this.validateFieldset();
        }
        for(let field of this.fields) {
            field.addEventListener('input', this.onFieldChange)
            field.addEventListener('change', this.onFieldChange)
        }
    }

    validateFieldset() {
        for (let field of this.fields) {
            let inputs = this.el.querySelectorAll("[name='"+ field.name +"']");

            // Require selecting at least one checkbox
            if (field.type == 'checkbox' && field.classList.contains('required') && inputs.length > 1) {
                var form_data = new FormData(field.form);
                if (!form_data.has(field.name)) return false
            }

            if (field.required && !field.checkValidity()) return false
        }

        return true;
    }

    destroy() {
        for(let field of this.fields) {
            field.removeEventListener('input', this.onFieldChange)
            field.removeEventListener('change', this.onFieldChange)
        }
    }
}
